export default {
  "content": "<path d=\"M17.128 17.925c.226.24.212.505.172.612h-4.127V21h-2.436v-2.463h-4.06v-2.143l6.563-8.401H6.93v-2.53l3.807.04V3h2.436v2.49h3.861V7.5l-6.577 8.454c0 .027 4.687.027 5.499.053.04.027.133.307.253.546.266.546.559.972.919 1.372z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};